// Persistencia leve de anotacoes do operador no LineChart avancado
// (modo Analise avancada). Cada anotacao tem timestamp + texto e fica
// salva no localStorage scopada por (thingId, ihmname) — permite
// documentar investigacoes sem persistencia backend.
//
// Ex.: operador investigando spike de 03:21 anota "valvula 4 travou,
// trocada 08h" — proxima vez que abrir o modal pra essa variavel/
// maquina, a anotacao aparece como ReferenceLine no chart.
//
// Limitacao: localStorage e por-browser, nao sincroniza entre estacoes
// do CCO. Pra colaboracao precisa de endpoint backend (futuro).

const STORAGE_PREFIX = 'chart-annot:';
const keyFor = (thingId, ihmname) =>
  `${STORAGE_PREFIX}${thingId || 'noThing'}:${ihmname || 'noVar'}`;

export const loadAnnotations = (thingId, ihmname) => {
  if (typeof window === 'undefined' || !window.localStorage) return [];
  try {
    const raw = window.localStorage.getItem(keyFor(thingId, ihmname));
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch (e) {
    // JSON corrompido — descarta e zera
    return [];
  }
};

export const saveAnnotations = (thingId, ihmname, list) => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(
      keyFor(thingId, ihmname),
      JSON.stringify(list || [])
    );
  } catch (e) {
    // quota exceeded ou storage indisponivel — falha silenciosa
  }
};

export const addAnnotation = (thingId, ihmname, { timestamp, text }) => {
  const list = loadAnnotations(thingId, ihmname);
  // ID derivado de timestamp + crypto/random — stable enough pra key.
  // Date.now() + Math.random() suficiente, sem usar crypto.randomUUID
  // (suporte incompleto em browsers antigos).
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const next = [
    ...list,
    {
      id,
      timestamp,
      text,
      createdAt: Date.now(),
    },
  ];
  saveAnnotations(thingId, ihmname, next);
  return next;
};

export const removeAnnotation = (thingId, ihmname, id) => {
  const list = loadAnnotations(thingId, ihmname);
  const next = list.filter((a) => a.id !== id);
  saveAnnotations(thingId, ihmname, next);
  return next;
};
